export const firstLetterLowerCase = (value: string): string => {
  return value.charAt(0).toLowerCase() + value.slice(1);
};

export const formatDateStringWithoutTimezone = (value: string): string => {
  const date = new Date(value);
  const offset = date.getTimezoneOffset();
  const newDate = new Date(date.getTime() - offset * 60 * 1000);
  return newDate.toISOString().split('T')[0];
};
